import { BrowserRouter, Route, Routes } from "react-router";
// import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ForgotPassword from "./pages/ForgotPassword";
import DashboardPage from "./pages/DashboardPage";
import SharesPage from "./pages/SharesPage";
import ContributionPage from "./pages/ContributionPage";
import { AuthProvider } from "./context";
import ProtectedRoute from "./context/protect";
import ProfilePage from "./pages/ProfilePage";
import { ApolloProvider } from "@apollo/client";
import client from "./apollo/ApolloClient";
import UsersPage from "./pages/UsersPage";
import LandingPage from "./pages/LandingPage";
import SingUpPage from "./pages/SingupPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ContactPage from "./pages/ContactPage";
import SupportPage from "./pages/SupportPage";

function App() {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <ApolloProvider client={client}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<SingUpPage />} />
              <Route path="/forgot" element={<ForgotPassword />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/dashboard" element={<ProtectedRoute> <DashboardPage /> </ProtectedRoute>} />
              <Route path="/shares" element={<ProtectedRoute> <SharesPage /> </ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute> <UsersPage /> </ProtectedRoute>} />
              <Route path="/contributions" element={<ProtectedRoute> <ContributionPage /> </ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute> <ProfilePage />  </ProtectedRoute>} />
            </Routes>
          </ApolloProvider>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
